export const state = {
  S: {
    ENG: 'english',
    CHI: 'chinese'
  },
  U: 'chinese'
}

// function getLang () {
//   if (navigator.languages !== undefined) {
//     return navigator.languages[0]
//   } else {
//     return navigator.language
//   }
// }

// if (getLang().indexOf('en') !== -1) {
//   state.U = 'english'
// }
// console.log(getLang())

export const ENG = state.S.ENG
export const CHI = state.S.CHI

export const lang = [
  // {
  //   name: '/@radiance-text',
  //   english: `Clé de Peau Beauté brings radiance to the skin and every aspect of every women’s life. Together with Make-A-Wish Hong Kong and with your support, we can illuminate lives and grant more wishes to the ones in need.`,
  //   chinese: `Clé de Peau Beauté是法語「肌膚之鑰」的意思，發掘每位女性的深藏麗質，開啟源自內在的閃耀力量。一起與願望成真基金為受惠病童實現願望，好比天上閃爍璀璨的耀目明星，引領他們奮勇向前，永不言棄。`
  // },
  // {
  //   name: '/@radiance-promo',
  //   english: `
  //   From April 4-29, raise 5,000 radiance for the Wish Children and Clé de Peau Beauté will donate HK$150,000 to Make-A-Wish Hong Kong.
  //   `,
  //   chinese: `
  //   在4月4日至29日，為願望童籌集5,000個閃耀力量，Clé de Peau Beauté將會向願望成真基金捐出港幣$150,000， 傳承閃耀。
  //   `
  // },
  {
    name: '/@radiance-is',
    english: `
    Radiance is...
    `,
    chinese: `
    她們的閃耀力量時刻
    `
  },
  {
    name: '/@counter-days',
    english: `
      Days
    `,
    chinese: `
      日
    `
  },
  {
    name: '#menu@lang',
    english: `
      繁
    `,
    chinese: `
    Eng
    `
  },
  {
    name: '/@counter-radiance',
    english: `
      Radiance
    `,
    chinese: `
      顆閃耀力量
    `
  },
  {
    name: '/@counter-radiance-to-go-to-go',
    english: `

    `,
    chinese: `
      尚要
    `
  },
  {
    name: '/@counter-radiance-to-go',
    english: `
      Radiance to go
    `,
    chinese: `
      顆閃耀力量
    `
  },

  // ---
  {
    name: '/game-start@how-to-unlock',
    english: `
      Ways to collect 5,000 Radiance
    `,
    chinese: `
      如何籌集5,000顆閃耀力量
    `
  },
  {
    name: '/game-start@ways-to-get',
    english: `
    1. Unlock the power of your radiance
    `,
    chinese: `
    1. 開啟您的「閃耀力量」
    `
  },
  {
    name: '/choose-photo@step-1',
    english: `
      Step 1
    `,
    chinese: `
      第一步
    `
  },
  {
    name: '/choose-photo@choose-image',
    english: `
      Select an image
    `,
    chinese: `
      挑選您的照片
    `
  },
  {
    name: '/choose-photo@take-photo',
    english: `
      Take Photo
    `,
    chinese: `
      拍攝相片
    `
  },
  {
    name: '/choose-photo@upload-photo',
    english: `
    Upload Photo
    `,
    chinese: `
      上傳相片
    `
  },
  {
    name: '/choose-photo@default-photo',
    english: `
      Default Photo
    `,
    chinese: `
      預設圖像
    `
  },
  {
    name: '/choose-photo@please-center-photo',
    english: `Please center your face and drag`,
    chinese: `以獲得更佳效果，請選擇面部置中的照片，`
  },
  {
    name: '/choose-photo@get-the-best-effect',
    english: `\nthe photo to adjust the best position.`,
    chinese: `\n並隨意拉動相片，以獲得最佳效果 。`
  },
  // {
  //   name: '/choose-photo@please-center-photo',
  //   english: `
  //   Please Center your face so as to
  //   `,
  //   chinese: `
  //   以獲得更佳效果，請盡量使面部置中
  //   `
  // },
  // {
  //   name: '/choose-photo@get-the-best-effect',
  //   english: `
  //   get the best effect.
  //   `,
  //   chinese: `
  //   及保持充足光源。
  //   `
  // },
  {
    name: '/choose-photo@choose-another-photo',
    english: `
      Choose another photo
    `,
    chinese: `
      重選照片
    `
  },
  {
    name: '/choose-photo@next',
    english: `
      Next
    `,
    chinese: `
      下一步
    `
  },
  {
    name: '/choose-photo@default',
    english: `Default image`,
    chinese: `預設圖象`
  },

  {
    name: '/define-radiance@step2',
    english: `
      Step 2
    `,
    chinese: `
      第二步
    `
  },

  {
    name: '/define-radiance@title',
    english: `
      Define your radiance
    `,
    chinese: `
      挑選您的閃耀時刻
    `
  },
  {
    name: '/define-radiance@next',
    english: `
      Next
    `,
    chinese: `
      下一步
    `
  },
  {
    name: '/define-radiance@adjust-photo',
    english: `
      Back
    `,
    chinese: `
      上一步
    `
  },

  {
    name: '/data-form@step3',
    english: `
    STEP 3
    `,
    chinese: `
    第三步
    `
  },
  {
    name: '/data-form@step-desc-1',
    english: `
    Would you like to be the first one
    `,
    chinese: `
    您想率先預覽閃耀肌膚資訊嗎?
    `
  },
  {
    name: '/data-form@step-desc-2',
    english: `
    to receive our latest news?
    `,
    chinese: `
    `
  },
  {
    name: '/data-form@step-desc-3',
    english: `
    `,
    chinese: `
    `
  },
  {
    name: '/data-form@first-name',
    english: `
    First Name
    `,
    chinese: `
    姓
    `
  },
  {
    name: '/data-form@last-name',
    english: `
    Last Name
    `,
    chinese: `
    名
    `
  },
  {
    name: '/data-form@area-code',
    english: `
    Area Code
    `,
    chinese: `
    區號
    `
  },
  {
    name: '/data-form@contact-phone',
    english: `
    Mobile
    `,
    chinese: `
    聯絡電話
    `
  },
  {
    name: '/data-form@email-address',
    english: `
    Email Address
    `,
    chinese: `
    電郵地址
    `
  },
  {
    name: '/data-form@email',
    english: `
    Email
    `,
    chinese: `
    電郵
    `
  },
  {
    name: '/data-form@mobile',
    english: `
    Mobile
    `,
    chinese: `
    手提電話
    `
  },
  {
    name: '/data-form@sms',
    english: `
    SMS
    `,
    chinese: `
    SMS短訊
    `
  },
  {
    name: '/data-form@agree',
    english: `
    I have read and understood the Personal Information Collection Statement.
    `,
    chinese: `
    本人已細閱及同意有關收集個人資料聲明
    `
  },
  {
    name: '/data-form@red',
    english: `(Required)`,
    chinese: `(請填寫資料)`
  },
  {
    name: '/data-form@submit',
    english: `
    Submit
    `,
    chinese: `
    提交
    `
  },
  {
    name: '/data-form@no-thanks',
    english: `
    No, thank you!
    `,
    chinese: `
    不用了，謝謝!
    `
  },

  {
    name: '/unlock@unlocking-title',
    english: `
    UNLOCK THE POWER OF YOUR RADIANCE
    `,
    chinese: `
    開啟您的閃耀力量
    `
  },

  {
    name: '/share-page@title-1',
    english: `Thank you for your participation,`,
    chinese: `感謝您的參與，`
  },
  {
    name: '/share-page@title-2',
    english: `you have raise one radiance.`,
    chinese: `您可分享予他人，\n籌集第二顆閃耀力量。`
  },
  {
    name: '/share-page@title-3',
    english: `Spark and share with your friends to raise extra radiance!`,
    chinese: `希望您能傳承，\n並創造更多閃耀力量。`
  },
  {
    name: '/share-page@cta-text',
    english: `
    Share your radiance
    `,
    chinese: `
    傳承您的閃耀力量
    `
  },
  {
    name: '/share-page@kids-wishes',
    english: `
    About Wish Children
    `,
    chinese: `
    願望童
    `
  },
  {
    name: '/share-page@thanks-for-joining-1',
    english: `
    Ways to collect
    `,
    chinese: `
    目標閃耀力量
    `
  },
  {
    name: '/share-page@thanks-for-joining-2',
    english: `
     Radiance
    `,
    chinese: `
    顆
    `
  },
  {
    name: '/share-page@collected',
    english: `
    Radiance collected
    `,
    chinese: `
    累積閃耀力量
    `
  },
  {
    name: '/share-page@remain',
    english: `
    Days to go
    `,
    chinese: `
    尚餘日數
    `
  },

  //
  {
    name: '/template@',
    english: `
    `,
    chinese: `

    `
  },
  {
    name: '/template@',
    english: `
    `,
    chinese: `

    `
  },
  //

  {
    name: '/game-start@unlock-radiance-cta',
    english: `UNLOCK your radiance`,
    /* eslint-disable */
    chinese: `　開啟您的「閃耀力量」　`
    /* eslint-enable */
  }
]

export const T = (query) => {
  var result = lang.find((i) => { return i.name === query })
  if (result) {
    return result[state.U] || query
  } else {
    return query
  }
}

export const TT = (obj) => {
  return obj[state.U]
}

export const toggle = () => {
  let e = state.U
  if (e === ENG) {
    state.U = CHI
  } else if (e === CHI) {
    state.U = ENG
  }
}



// WEBPACK FOOTER //
// ./src/components/DOM/Text/Text.js